import { TooltipWrapper } from '@/ui/TooltipWrapper';
import { Heart } from '@phosphor-icons/react/dist/ssr';
import classnames from 'classnames';
import { forwardRef } from 'react';
import * as styles from '../PostActions.css';

type LikeData = {
  isLiked?: boolean;
  likesCount?: number;
};

type LikeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  data: LikeData;
};

const LikeButton = forwardRef<HTMLButtonElement, LikeButtonProps>(({ data, ...props }, ref) => {
  return (
    <button ref={ref} type="submit" className={classnames('flex justify-center', styles.button)} {...props}>
      <Heart size="20" weight={data?.isLiked ? 'fill' : undefined} />
      {data?.likesCount || ''}
    </button>
  );
});

type LikeActionButtonProps = LikeButtonProps & {
  translations?: Record<string, string>;
};

export const LikeActionButton = ({ data, translations, ...props }: LikeActionButtonProps) => {
  if (translations?.['search.pagination.like']) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={translations['search.pagination.like']}>
        <LikeButton data={data} {...props} />
      </TooltipWrapper>
    );
  }

  return <LikeButton data={data} {...props} />;
};
